import React from 'react';
import { EmotionContext } from '../context/emotion-context';

export function withEmotion(Component) {
  return props => (
    <EmotionContext.Consumer>{emotion => <Component {...props} emotion={emotion} />}</EmotionContext.Consumer>
  );
}
